var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"circleItem",staticClass:"circle-item",style:({
    width: _vm.width + 'px',
    height: _vm.width + 'px',
    left: _vm.initPos.x + 'px',
    top: _vm.initPos.y + 'px'
  })},[_c('img',{ref:"imgRef",staticClass:"circle-item__img spin",attrs:{"src":_vm.img,"alt":"technology"},on:{"mouseover":_vm.spin}})])
}
var staticRenderFns = []

export { render, staticRenderFns }